import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const DownloadCall: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.99194 12V24H11.9999H22.0079V14.79V5.57993L19.2179 2.78995L16.4279 0H9.2099H1.99194V12ZM4.00794 12V22.008H11.9999H19.9919V14.214V6.4199L17.7779 4.20595L15.5638 1.992H9.78589H4.00794V12ZM10.9919 10.7819V13.5718L10.0919 12.672L9.19187 11.7722L8.48392 12.4801L7.77594 13.1881L9.88794 15.3L11.9999 17.4119L14.1119 15.3L16.2239 13.1881L15.516 12.4801L14.808 11.7722L13.908 12.672L13.0079 13.5718V10.7819V7.992H11.9999H10.9919V10.7819Z'
      fill={fill}
    />
  </svg>
)

export default DownloadCall
